import { Box } from "@mui/material";
import styled from "styled-components";

export const LoginStyled = styled(Box)`
  padding: 56px;
  @media (max-width: 768px) {
    padding: 24px;
    margin-top: 40px !important;
  }

  .container {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 18px;
    margin-top: 24px;
    .form-wrapper {
      width: 100%;
      max-width: 548px;
    }

    @media (max-width: 768px) {
      width: 100%;
      .form-wrapper {
        width: 100%;
        max-width: unset;
      }
    }

    .title {
      font-weight: 600;
      font-size: 36px;
      color: var(--dark-gray-color);
      margin-bottom: 16px;

      @media (max-width: 768px) {
        font-size: 28px;
      }
    }

    .buttons-container {
      margin-top: 32px;
      .primary-button {
        display: flex;
      }
    }

    .link {
      display: flex;
      justify-content: center;
      position: relative;
      margin-top: 12px;

      .MuiTypography-root {
        font-size: 14px;
        font-weight: 500;
        a {
          color: var(--royal-blue-color);
          text-decoration: none;
          cursor: pointer;
        }
      }

      .forgot {
        position: absolute;
      }
    }
  }

  .forgot-password {
    margin-top: 4px;
    display: flex;
    justify-content: end;
    color: var(--royal-blue-color);
    text-decoration: none;
    cursor: pointer;

    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export const BrandingStyled = styled(Box)`
  width: 50%;
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
